const baseURL = "https://chatbot.kanplas.com/api";

export const LOGIN_URL = `${baseURL}/user/login`;
export const GET_STATS_URL = `${baseURL}/app/stats`;

export const GET_RECORDS_URL = `${baseURL}/app/records`;